import React from 'react';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import TpPrePaymentPaymentItem from '../../../../Domain/TpPrePaymentPaymentItem';
import TpClientPaymentService from '../../../../Services/tpClientPaymentService';

export default class TpRelatedClientPrePaymentDetailsPaymentsTab extends React.Component {
  static defaultProps = {
    prepaymentId: 0
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: props.prepaymentId
    };
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={TpPrePaymentPaymentItem}
          serviceFunction={TpClientPaymentService.GetTpRelatedPrePaymentsBySearching}
          convertDBItemsFunction={TpClientPaymentService.ConvertTpPrePaymentPaymentDBItems}
          searchItem={this.state.searchItem}
          orderBy='PaymentDate'
          orderDirection='Desc'
          errorCode='CPPDPT28'
        />
      </div>
    );
  }
}
